var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('snack',{attrs:{"text":_vm.objAlert.message,"color":_vm.objAlert.type,"snackbar":_vm.objAlert.show},on:{"close":function($event){return _vm.closeSnack()}}}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }